import TextComponent from 'app_components/commons/TextComponent/TextComponent'
import ActivitySummaryModule from 'app_components/modules/campus/academic/activitySummary'
import NotesAchievedModule from 'app_components/modules/campus/academic/notesAchieved'
import React, { FC, useMemo } from 'react'
import { useSelector } from 'react-redux'
import StudentDashboardCourseInformation, { StudentDashboardCourseInformationMode } from '../StudentDashboardCourseInformation/StudentDashboardCourseInformation'
import StudentDashboardCustomAccordion from '../StudentDashboardCustomAccordion/StudentDashboardCustomAccordion'
import StudentDashboardSelectCourse, { SelectCourseType } from '../StudentDashboardSelectCourse/StudentDashboardSelectCourse'
import { CombinedReducers } from 'app_events/index';

import './StudentsDashboardHistoryCourses.scss'
import StudentDashboardLearningPath from '../StudentDashboardLearningPath/StudentDashboardLearningPath'
import { STUDENT_DASHBOARD_TAB } from '../../StudentDashboardPage'
import StudentDashboardCourseCriteria from '../StudentDashboardCourseCriteria/StudentDashboardCourseCriteria'
import { CourseSchedulingCourseType } from 'app_types/admin/courseScheduling/courseSchedulingTypes'
import StudentDashboardCurrentStatus from '../StudentDashboardCurrentStatus/StudentDashboardCurrentStatus'
import DurationFieldService from 'app_services/components/durationFieldService'

const INFORMATION_MODES: StudentDashboardCourseInformationMode[] = [
  StudentDashboardCourseInformationMode.HISTORY,
  StudentDashboardCourseInformationMode.ACTIVITIES,
  StudentDashboardCourseInformationMode.SERVICE,
]

const typeCourseTranslation = {
  [CourseSchedulingCourseType.FREE]: "Curso Gratuito",
  [CourseSchedulingCourseType.MOOC]: "Mooc",
}

const StudentsDashboardHistoryCourses: FC = () => {
  const { courseSelected } = useSelector((state: CombinedReducers) => state.courses)
  const durationFieldService = useMemo(() => new DurationFieldService(), [])
  const typeCourseText = courseSelected?.typeCourse ? typeCourseTranslation[courseSelected?.typeCourse] : null
  const isFreeOrMooc = courseSelected?.typeCourse ? [CourseSchedulingCourseType.FREE, CourseSchedulingCourseType.MOOC].includes(courseSelected?.typeCourse) : false

  return (
    <div className="students-dashboard-history-courses--layout">
      <StudentDashboardSelectCourse
        courseType={SelectCourseType.HISTORY}
        alertText='Aún no tienes cursos.'
      >
        <div className="students-dashboard-history-courses--content">
          <div>
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
              <TextComponent type='subtitle'>{courseSelected?.name ? courseSelected?.name : ''}</TextComponent>
              {typeCourseText?.length && (
                <span className='students-dashboard-history-courses--course-type'>
                  {typeCourseText}
                </span>
              )}
              {isFreeOrMooc && (
                <div style={{ marginLeft: 'auto' }}>
                  <StudentDashboardCurrentStatus />
                </div>
              )}
            </div>
            <div className='students-dashboard-history-courses--info-service'>
              <TextComponent fontSize='1.1rem'>ID: {courseSelected?.service_id}</TextComponent>
              <TextComponent fontSize='1.1rem'>Modalidad: {courseSelected?.schedulingMode?.name}</TextComponent>
            </div>
            {!!courseSelected?.serviceValidity && isFreeOrMooc && (
              <TextComponent fontSize='1.1rem'>Tiempo de vigencia: {durationFieldService.getDurationFormated(courseSelected.serviceValidity, 'large')}</TextComponent>
            )}
          </div>
          <StudentDashboardCustomAccordion>
            <StudentDashboardCourseCriteria />
          </StudentDashboardCustomAccordion>
          <StudentDashboardCustomAccordion>
            <StudentDashboardLearningPath />
          </StudentDashboardCustomAccordion>
          <StudentDashboardCustomAccordion>
            <ActivitySummaryModule />
          </StudentDashboardCustomAccordion>
          <StudentDashboardCustomAccordion>
            <NotesAchievedModule />
          </StudentDashboardCustomAccordion>
          <TextComponent type='subtitle'>Información del curso</TextComponent>
          <StudentDashboardCourseInformation tab={STUDENT_DASHBOARD_TAB.HISTORY} modes={INFORMATION_MODES} />
        </div>
      </StudentDashboardSelectCourse>
    </div>
  )
}

export default StudentsDashboardHistoryCourses
